import { lazy } from 'react';
const Index = lazy(() => import('@/pages/Payment'));
const Payment1 = lazy(() => import('@/pages/Payment1'));
const Success = lazy(() => import('@/pages/Payment/Success'));
const Faild = lazy(() => import('@/pages/Payment/Faild'));
const Expired = lazy(() => import('@/pages/Payment/Expired'));
const Invitation = lazy(() => import('@/pages/Invitation'));
const Invitation1 = lazy(() => import('@/pages/Invitation/1'));

const routes: any = [
  {
    path: '/',
    component: Index,
    title: 'Payment',
  },
  {
    path: '/payment',
    component: Payment1,
    title: 'Payment',
  },
  {
    path: '/faild',
    component: Faild,
    title: 'Faild',
  },
  {
    path: '/success',
    component: Success,
    title: 'Success',
  },
  {
    path: '/expired',
    component: Expired,
    title: 'Expired',
  },
  {
    path: '/invitation',
    component: Invitation,
    title: 'Invitation',
  },
  {
    path: '/invitation1',
    component: Invitation1,
    title: 'Invitation',
  },
];

export default [...routes];
